import React, { memo, useContext } from "react";
import PropTypes from "prop-types";
import "./header.scss";

import { UserMenu } from "@hoteltradergit/user-management";

import { PropertyStoreContext } from "../../contexts/PropertyStoreContext";

import PropertySelect from "../property-select/PropertySelect";
import usePropertyHeaderSearch from "../../hooks/usePropertyHeaderSearch";

import MenuExpandIcon from "../../assets/img/menu_expand.svg?react";
import MenuCollapseIcon from "../../assets/img/menu_collapse.svg?react";

const Header = ({ isSidebarOpen, onToggleSidebar }) => {
  const { setSelectedProperty, selectedProperty } =
    useContext(PropertyStoreContext);
  const { searchText, setSearchText, results, totalCount, loading } =
    usePropertyHeaderSearch();

  return (
    <header className="header">
      {/* Left: sidebar toggle */}
      <button
        type="button"
        className="sidebar-toggle"
        onClick={onToggleSidebar}
        aria-label={isSidebarOpen ? "Collapse sidebar" : "Expand sidebar"}
        aria-pressed={isSidebarOpen}
      >
        {isSidebarOpen ? <MenuCollapseIcon /> : <MenuExpandIcon />}
      </button>

      {/* Spacer pushes the next cluster to the right */}
      <div className="header__spacer" />

      <div className="header__right">
        <PropertySelect
          formClassName="header-property-select"
          options={results}
          totalCount={totalCount}
          loading={loading}
          searchText={searchText}
          onSearchTextChange={setSearchText}
          disabled={!selectedProperty}
          onSelectChange={setSelectedProperty}
          selectedProperty={selectedProperty}
        />

        <UserMenu />
      </div>
    </header>
  );
};

Header.propTypes = {
  isSidebarOpen: PropTypes.bool.isRequired,
  onToggleSidebar: PropTypes.func.isRequired,
};

export default memo(Header);
